
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobrenos",
      function () {
        return require("private-next-pages/sobrenos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sobrenos"])
      });
    }
  